export const defaultTimeRangeDays = 70;
